'use client';

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules';
import {
  StyledNotificationCard,
  IconContainer,
  TextContent,
  Subject,
  Message,
} from './styles';

export const NotificationCard = ({
  icon,
  subject,
  subjectTypography = 'bodyBold',
  subjectFontColor = 'text.primary',
  message,
  messageTypography = 'label',
  messageFontColor = 'text.secondary',
  delay = 0,
}) => {
  // Animates once on mount, then settles. Remount (e.g. tab becomes active
  // again) is what retriggers the entrance — re-clicks while mounted do not.
  const [animationState, setAnimationState] = useState('animating');

  const handleAnimationEnd = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    setAnimationState('settled');
  };

  return (
    <StyledNotificationCard
      data-testid="notification-card"
      $animationState={animationState}
      $delay={delay}
      onAnimationEnd={handleAnimationEnd}
    >
      {icon?.src && (
        <IconContainer>
          <ResponsiveImage
            src={icon.src}
            alt={icon.alt || ''}
            width={icon.width || 40}
            height={icon.height || 40}
            objectFit="contain"
          />
        </IconContainer>
      )}
      <TextContent>
        {subject && (
          <Subject
            $typography={subjectTypography}
            $fontColor={subjectFontColor}
          >
            {subject}
          </Subject>
        )}
        {message && (
          <Message
            $typography={messageTypography}
            $fontColor={messageFontColor}
          >
            {message}
          </Message>
        )}
      </TextContent>
    </StyledNotificationCard>
  );
};

NotificationCard.displayName = 'NotificationCard';

NotificationCard.propTypes = {
  icon: PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    alt: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  subject: PropTypes.string,
  subjectTypography: PropTypes.string,
  subjectFontColor: PropTypes.string,
  message: PropTypes.string,
  messageTypography: PropTypes.string,
  messageFontColor: PropTypes.string,
  delay: PropTypes.number,
};
